import { object, string } from 'yup';

export default object().shape({
  birthday: string()
    .matches(
      /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/,
      'Birthday should be MM/DD/YYYY format'
    ),
});
